// extracted by mini-css-extract-plugin
export var bottomWave = "bs_cW";
export var button = "bs_b7";
export var buttonContainer = "bs_N";
export var buttonFooter = "bs_fw";
export var container = "bs_h";
export var middleWave = "bs_cV";
export var section = "bs_j";
export var subtitle = "bs_cq";
export var textContainer = "bs_bV";
export var title = "bs_d";